<template>
  <div>
    <SpaNav :selectIndex="5"/>
    <MobileNavBar/>
    <DemoForm/>
    <CallMe/>
  </div>
</template>

<script>
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import DemoForm from '@/components/demo'
import CallMe from '@/components/callme/index'
import SpaNav from '@/components/report_list/SpaNav.vue';
export default {
  components: {
    SpaNav, 
    MobileNavBar,
    DemoForm,
    CallMe,
  },
}
</script>

<style>
</style>